export enum ReportTypes {
    Form_1_2 = 2,
    Form_3 = 3,
    Form_4 = 4,
    Form_5 = 5,
    Form_6 = 6,
    Form_7 = 7,
    Form_8 = 8,
}
